"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodHttpURLRoot = exports.ZodHttpURL = void 0;
/**
 * This file contains Zod extensions
 */
const v4_1 = require("zod/v4");
exports.ZodHttpURL = v4_1.z
    .string({
    error: "Enter a valid URL address",
})
    .transform((value) => {
    try {
        // If URL is valid, then use the URL as is.
        new URL(value);
        return value;
    }
    catch (_a) {
        // No protocol/invalid URL - assume https://
        return `https://${value}`;
    }
})
    .pipe(v4_1.z
    .url({ error: "Enter a valid URL address" })
    .nonempty({ error: "Enter a valid URL address" })
    .refine((value) => {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol);
}, "Enter a valid website address"));
/** Checks that the given URL is a root of the website and no pathname is given **/
exports.ZodHttpURLRoot = exports.ZodHttpURL.refine((value) => {
    const url = new URL(value);
    return url.pathname === "/";
}, "Please enter only the main website address (e.g. https://example.com)").transform((value) => {
    if (value.endsWith("/")) {
        return value.slice(0, -1);
    }
    return value;
});
